import React from 'react';
import MeetingCard from './MeetingCard.tsx';
import { Calendar as CalendarIcon } from 'lucide-react';
import { Meeting } from '../../../services/meeting.service.ts';

interface ScheduledMeetingsListProps {
  meetings: Meeting[];
  onDelete: (id: string) => void;
  onRefresh: () => void;
}

const ScheduledMeetingsList: React.FC<ScheduledMeetingsListProps> = ({ meetings, onDelete, onRefresh }) => {
  if (meetings.length === 0) {
    return (
      <div className="bg-white/5 backdrop-blur-sm rounded-xl sm:rounded-2xl border border-white/10 p-6 sm:p-12 text-center">
        <CalendarIcon className="w-12 h-12 sm:w-16 sm:h-16 text-gray-500 mx-auto mb-3 sm:mb-4" />
        <p className="text-gray-400 text-base sm:text-lg">Henüz planlanmış toplantı yok</p>
        <p className="text-gray-500 text-xs sm:text-sm mt-2">Yeni bir toplantı oluşturmak için yukarıdaki butona tıklayın</p>
      </div>
    );
  }

  return (
    <div className="space-y-3 sm:space-y-4">
      {meetings.map((meeting) => (
        <MeetingCard key={meeting.id} meeting={meeting} onDelete={onDelete} />
      ))}
    </div>
  );
};

export default ScheduledMeetingsList;